/**
 * The free-trial length (contract batch 10b).
 *
 * The backend's STRIPE_TRIAL_PERIOD_DAYS is the truth: it is what Checkout passes to
 * Stripe, and /payments/status/ states it as `trial_period_days`. Signed-in
 * surfaces read that. The public pages (landing, signup) cannot call an authed
 * endpoint, so they read this constant, which
 * backend/tests/test_contract_b10_trial.py pins to the setting's default. The
 * pages typed "7-day" in nine places before.
 */
export const TRIAL_DAYS = 7;

/** "7-day", for "a 7-day free trial". */
export function trialLength(days: number = TRIAL_DAYS): string {
  return `${days}-day`;
}
